import * as React from 'react'
import dynamic from 'next/dynamic'

import {Card, CardItem} from '@components/Card'
import {
  IconCheckList,
  IconPresent,
  IconLightBulb,
  IconAudit,
  IconDocumentHeader,
} from '@components/Icon'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const Meta = dynamic(() => import('@components/Meta'))

import {logEvent} from '@lib/gtm'

const services = {
  header: '5 บริการหลักของ PDPA Core',
  features: [
    {
      icon: <IconCheckList />,
      title: 'PDPA Implementation',
      body: 'บริการวิเคราะห์ช่องว่างที่จะช่วยเหลือในการดำเนินธุรกิจขององค์กรให้มีความสอดคล้องกับ PDPA ผ่านการตรวจสอบ ประเมิน รวมถึงให้คำแนะนำ ในการปรับปรุงแก้ไขในส่วนของการบริหารจัดการ และกระบวนการทำงานขององค์กรที่มีความเกี่ยวข้องกับ ข้อมูลส่วนบุคคล',
    },
    {
      icon: <IconPresent />,
      title: 'PDPA Training and Seminars',
      body: 'จัดการฝึกอบรมความรู้ทั่วไปและสาระสำคัญของ PDPA ให้กับบุคลากรภายในองค์กร พร้อมทั้งเสริม สร้างความตระหนักรู้หน้าที่ของตนภายในองค์กร รวมถึงมาตรการที่ควรปฏิบัติเบื้องต้นเพื่อให้สอดคล้อง กับ PDPA ณ ปัจจุบัน ออกแบบและบรรยาย โดยผู้เชี่ยวชาญด้านกฎหมายคุ้มครองข้อมูลส่วนบุคคล',
    },
    {
      icon: <IconLightBulb />,
      title: 'PDPA Advisory',
      className: 'Products__grid-2',
      body: 'บริการให้คำปรึกษาและคำแนะนำโดยนักกฎหมายผู้เชี่ยวชาญเกี่ยวกับแนวปฎิบัติหรือข้อสงสัยที่เกี่ยวข้องกับ PDPA เรามีแพ็กเกจหลากหลายให้เลือกตามความเหมาะสมและความต้องการของคุณ',
    },
    {
      icon: <IconAudit />,
      title: 'PDPA Compliance Audit',
      body: 'ดำเนินการตรวจสอบในมุมมองทางกฎหมายสำหรับ กระบวนการทำงาน มาตรการที่มีอยู่ นโยบายในการคุ้มครองข้อมูลส่วนบุคคลของบริษัท รวมถึงเอกสารที่เกี่ยวข้องกับข้อมูลส่วนบุคคลทั้งหมด เพื่อนำมาจัดทำ Compliance Audit Report และให้คำแนะนำเกี่ยวกับแนวทางการปฏิบัติให้ สอดคล้องกับ PDPA โดยนักกฎหมายผู้เชี่ยวชาญ',
    },
    {
      icon: <IconDocumentHeader />,
      title: 'PDPA Documentation',
      body: 'บริการจัดทำ/ตรวจสอบ/แก้ไขเอกสารทางกฎหมาย (Legal Documents) ที่เกี่ยวกับ PDPA เพื่อช่วยให้ธุรกิจของคุณสอดคล้องกับ PDPA โดยสามารถปรับแต่งตามงบประมาณที่คุณจัดสรรได้อีกด้วย',
    },
  ],
}

const PDPAProject = [
  {
    icon: '/images/products/pdpa/cw',
    name: 'Cookie Wow',
    body: 'ระบบสร้างและจัดการแบนเนอร์คุกกี้และ Cookie Consent บนเว็บไซต์',
  },
  {
    icon: '/images/products/pdpa/form',
    name: 'PDPA Form',
    body: 'ระบบจัดการคำร้องคำขอใช้สิทธิของเจ้าของข้อมูล',
  },
  {
    icon: '/images/products/pdpa/learn',
    name: 'LearnPDPA',
    body: 'แพลตฟอร์ม e-learning สำหรับให้พนักงานเรียนรู้ PDPA ด้วยตนเอง',
  },
  {
    icon: '/images/products/pdpa/prokit',
    name: 'PDPA Prokit',
    body: 'เอกสารและคู่มือมากกว่า 69 ชุดที่ช่วยให้องค์กรปฏิบัติตาม PDPA',
  },
  {
    icon: '/images/products/pdpa/ucp',
    name: 'UCP',
    body: 'จัดการ Consent, คำร้องขอใช้สิทธิ, ROPA, Cookie Consent ในที่เดียว',
  },
]

export default function PDPACore(): JSX.Element {
  return (
    <React.Fragment>
      <Meta
        title='PDPA Consultant บริการให้คำปรึกษา วางแผน พร้อมจัดทำ PDPA'
        description='ทลายทุกขีดจำกัด ด้วยการนำ AI และเครื่องมือ Machine Learning มาใช้งาน เพื่อควบคุม ตรวจสอบคุณภาพ วางแผนให้องค์กรสามารถก้าวไปข้างหน้าได้อย่างเต็มที่'
      />

      <div className='Products'>
        <div className='container'>
          <div className='Products__hero'>
            <div>
              <h1>
                PDPA Core | บริการ <span>PDPA Consult</span>
              </h1>
              <p>
                <strong>บริการ PDPA Core จาก Data Wow</strong>
                <br />
                เป็นบริการให้คำปรึกษาพร้อมจัดทำ PDPA ครบวงจร
                โดยดำเนินการให้ธุรกิจสอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลพ.ศ.
                2562 (”PDPA”) โดยทีมนักกฎหมายเชี่ยวชาญ พร้อมเทคโนโลยีครบครัน
              </p>
              <a
                className='Produces__block__button'
                href='https://pdpacore.com/'
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => {
                  logEvent({
                    ga: {
                      category: 'Accurately',
                      action: 'Click Try Accurately',
                    },
                  })
                }}
              >
                อ่านเพิ่มเติมเกี่ยวกับ PDPA Core
              </a>
            </div>

            <div className='Products__img'>
              <figure className='Products__img__figure'>
                <picture>
                  <source
                    srcSet='/images/products/PPDACore.webp, /images/products/PPDACore@2x.webp 2x'
                    type='image/webp'
                  />
                  <source
                    srcSet='/images/products/PPDACore.png, /images/products/PPDACore@2x.png 2x'
                    type='image/png'
                  />
                  <img
                    src='/images/PPDACore.png'
                    srcSet='/images/PPDACore.png, /images/PPDACore@2x.png 2x'
                    alt='AI Consultation'
                    className='Index__face-detector__img'
                    width='465'
                    height='465'
                    loading='lazy'
                  />
                </picture>
              </figure>
            </div>
          </div>

          <div className='Products__content__header'>
            <h2>{services.header}</h2>
            <div className='Products__block'>
              <Card className='Products__card'>
                {services.features.map((feature, featureIndex) => (
                  <CardItem
                    key={`${featureIndex}`}
                    icon={feature.icon}
                    className={feature.className}
                    title={feature.title}
                    body={feature.body}
                  />
                ))}
              </Card>
            </div>
          </div>
          <div className='Products__other'>
            <div className='Products__other__head'>
              <p>
                เครื่องมืออื่น ๆ ที่<strong>ช่วยองค์กร</strong>สอดคล้อง{' '}
                <strong>PDPA ได้ง่าย ๆ</strong>
              </p>
            </div>
            <div className='Products__other__card'>
              {PDPAProject.map(({icon, name, body}) => (
                <div className='Products__other__card__item' key={name}>
                  <picture>
                    <source
                      srcSet={`${icon}.webp, ${icon}@2x.webp 2x`}
                      type='image/webp'
                    />
                    <source
                      srcSet={`${icon}.png, ${icon}@2x.png 2x`}
                      type='image/png'
                    />
                    <img
                      src={`${icon}.png`}
                      srcSet={`${icon}.png, ${icon}@2x.png 2x`}
                      alt={name}
                      className='Products__other__card__item__img'
                      loading='lazy'
                    />
                  </picture>
                  <p className='Products__other__card__item__detail'>
                    <strong>{name}</strong>
                    <br />
                    {body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

PDPACore.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}
